import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LegalPage from "../components/LegalPage";

export default function LegalRoute({ type }) {
  return (
    <>
      <Header />
      <LegalPage type={type} />
      <Footer />
    </>
  );
}
